module.exports = __webpack_public_path__ + "img/top1.1f06b2fa.png";